/**
 * Sprachliche Kleinigkeiten, die überall auffallen.
 *
 * Anlass war „1 Nächte im Auto" in der Ladeansicht — daneben standen noch
 * „1 Stationen", „1 Tage" und „1 Ladestopps". Jede Stelle für sich ist eine
 * Lappalie; zusammen lassen sie eine Oberfläche unfertig wirken.
 *
 * Bewusst **kein** `Intl.PluralRules`: Deutsch hat zwar nur die Kategorien
 * `one` und `other`, aber die Mehrzahlform muss man ohnehin hinschreiben
 * („Nacht" → „Nächte" leitet sich nicht ab). Die Regel wäre also nur ein
 * Umweg zur selben Fallunterscheidung — und `Intl` steht in JavaScriptCore
 * zwar zur Verfügung, ist dort aber unnötiger Ballast.
 *
 * Reine Funktionen — wie alles unter `planner/`.
 */

/**
 * Zahl mit passender Ein- oder Mehrzahl.
 *
 *     anzahl(1, 'Nacht', 'Nächte')  // „1 Nacht"
 *     anzahl(3, 'Nacht', 'Nächte')  // „3 Nächte"
 *
 * Auch **null** nimmt die Mehrzahl: „0 Nächte", nicht „0 Nacht".
 */
export function anzahl(n: number, einzahl: string, mehrzahl: string): string {
  return `${n} ${n === 1 ? einzahl : mehrzahl}`;
}

/** Nur das Wort, ohne die Zahl — wenn die Zahl eigene Auszeichnung bekommt. */
export function wort(n: number, einzahl: string, mehrzahl: string): string {
  return n === 1 ? einzahl : mehrzahl;
}
